import { Text, Heading,Img} from "../../components";
import Footer from "components/Footer";
import Navbar from "components/Navbar";

export default function About() {
  return (
    <>
      {/* about us section */}
      <div className="w-full bg-gray-300">
        <div className="relative h-[780px] bg-gray-300">
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>
          </div>  
          
          <div className="flex justify-center bg-gray-300 py-24 md:py-5">
            {/* <div className="container-xs flex items-center justify-center md:flex-col md:px-5"> */}
            <div className="flex flex-row items-center justify-center w-full max-w-[1300px] px-10">
              <Heading size="headings" as="h2" className="text-[21px] font-semibold text-blue_gray-900 whitespace-nowrap">
                About us.
              </Heading>

              <div className="flex justify-center my-5">
                <Img
                  src="/images/elipse-blue.svg"
                  className="w-[500px] h-auto"
                />
              </div>

              
              <div className="w-full max-w-[1000px] flex flex-col mt-[78px] gap-9 md:self-stretch px-10">
                <Heading
                  size="headingmd"
                  as="h3"
                  className="relative top-6 text-[36px] font-semibold leading-[140%] text-blue_gray-900 md:text-[34px] sm:text-[32px]"
                >
                  <span className="text-blue_gray-900">
                    Tail Risk Global (TRG) was founded by Wall Street seasoned professionals in&nbsp;
                  </span>
                  <span className="text-pink-a200">
                    quantitative risk modeling at top-tier financial institutions covering a wide range of asset classes.
                    &nbsp;
                  </span>
                </Heading>
                <Text size="textmd" as="p" className="text-[16px] font-normal leading-[150%] text-black-900">
                  TRG brings cutting-edge risk modeling techniques, similar to those used by the largest financial
                  institutions, to the broader portfolio management community. Our goal was to create a fully
                  transparent, intuitive, and conceptually sound tool that enables on-the-spot decision making.{" "}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
          <Footer />
        </div>

    </>
  );
}
